import { useEffect } from 'react';
import Grid from '@mui/material/Grid';
import useEngageWorkQueueCounts from '../../hooks/useEngageWorkQueueCounts';
import { captureWorkQueueCountersView } from '../../utils/engageWorkQueueAnalytics';
import { WORK_QUEUE_TILES } from '../../utils/engageWorkQueueConfig';
import WorkQueueCounterTile from './WorkQueueCounterTile';

function WorkQueueCountersRow() {
  const counts = useEngageWorkQueueCounts();

  useEffect(() => {
    captureWorkQueueCountersView();
  }, []);

  return (
    <Grid container spacing={2}>
      {WORK_QUEUE_TILES.map((tile) => {
        const queueState = counts[tile.countKey];
        return (
          <Grid item xs={6} sm={4} md={4} lg={2} key={tile.id}>
            <WorkQueueCounterTile
              queueId={tile.id}
              label={tile.label}
              caption={tile.caption}
              to={tile.to}
              count={queueState.count}
              loading={queueState.loading}
              error={queueState.error}
            />
          </Grid>
        );
      })}
    </Grid>
  );
}

export default WorkQueueCountersRow;
